export class AuditLog {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonAccountDomain",
            "baseName": "eonAccountDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonOrganizationId",
            "baseName": "eonOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonOrganizationDomain",
            "baseName": "eonOrganizationDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "initiatorId",
            "baseName": "initiatorId",
            "type": "string",
            "format": ""
        },
        {
            "name": "initiatorName",
            "baseName": "initiatorName",
            "type": "string",
            "format": ""
        },
        {
            "name": "initiatorEmail",
            "baseName": "initiatorEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "initiatorRole",
            "baseName": "initiatorRole",
            "type": "string",
            "format": ""
        },
        {
            "name": "initiatorRoleId",
            "baseName": "initiatorRoleId",
            "type": "string",
            "format": ""
        },
        {
            "name": "initiatorType",
            "baseName": "initiatorType",
            "type": "AuditLogInitiatorType",
            "format": ""
        },
        {
            "name": "requestDetails",
            "baseName": "requestDetails",
            "type": "RequestDetails",
            "format": ""
        },
        {
            "name": "verb",
            "baseName": "verb",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "normalizedPath",
            "baseName": "normalizedPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "statusCode",
            "baseName": "statusCode",
            "type": "number",
            "format": ""
        },
        {
            "name": "operationName",
            "baseName": "operationName",
            "type": "string",
            "format": ""
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "AuditLogAction",
            "format": ""
        },
        {
            "name": "sourceIpAddress",
            "baseName": "sourceIpAddress",
            "type": "string",
            "format": ""
        },
        {
            "name": "userAgent",
            "baseName": "userAgent",
            "type": "string",
            "format": ""
        },
        {
            "name": "extendedData",
            "baseName": "extendedData",
            "type": "AuditLogExtendedData",
            "format": ""
        },
        {
            "name": "securityContext",
            "baseName": "securityContext",
            "type": "AuditLogSecurityContext",
            "format": ""
        },
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<AuditLogEntitiesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLog.attributeTypeMap;
    }
    constructor() {
    }
}
